import { action } from '../utils';
import { AppActionTypes, AppBreadcrumbState } from './types';

export const setBreadcrumbs = (breadcrumbs: AppBreadcrumbState[]) => action(AppActionTypes.SET_BREADCRUMBS, breadcrumbs);
